// В.2.e-1: общий каркас триггеров «когда этот юнит наносит атаку».
//
// API:
//   registerOnAttackTrigger(cardId, fn)
//     — fn(state, attacker, target, damageDealt) вызывается каждый раз,
//       когда attacker.id === cardId нанёс ударом физический урон цели.
//   fireOnAttackTrigger(state, attacker, target, damageDealt)
//     — вызывается из combat.js (unitVsUnit forward+backward, unitVsHero,
//       heroVsUnit, heroVsHero) после применения applyDamage. damageDealt =
//       armorAbsorbed + hpLost, БЕЗ immuneAbsorbed (Иммунитет = «удар не
//       состоялся»). Если damageDealt === 0 — fn всё равно вызывается с 0,
//       сама карта решает, что делать (Химера: 0 ХП Герою — событие healed
//       не эмитится через healUnit, корректно).
//
// Молчание блокирует: если у attacker.current.silenced или непустой
// silenceSources — fn не вызывается.
//
// Реестр по cardId — только Лив Лайф пока пользуется этим. Если потребуется
// в других фракциях — отдельный шаг рефакторинга.

// Этап 56-fix: cardId → СПИСОК handler'ов (раньше был один fn на id, и
// mods-batch регистрировал Кровавый имплант на ВСЕ юниты Синтетика,
// перезаписывая родные триггеры — напр. +1 Налётчика по Герою).
const _onAttackTriggers = new Map();

export function registerOnAttackTrigger(cardId, fn) {
  if (typeof cardId !== 'string' || typeof fn !== 'function') return;
  let arr = _onAttackTriggers.get(cardId);
  if (!arr) { arr = []; _onAttackTriggers.set(cardId, arr); }
  if (!arr.includes(fn)) arr.push(fn);
}

export function _resetOnAttackTriggersForTests() {
  _onAttackTriggers.clear();
}

// Вызывается из combat.js. attacker и target — Card-инстансы, damageDealt —
// число (целое >= 0).
export function fireOnAttackTrigger(state, attacker, target, damageDealt) {
  if (!attacker) return;
  if (_onAttackTriggers.size === 0) return;
  const arr = _onAttackTriggers.get(attacker.id);
  if (!arr || arr.length === 0) return;
  // Молчание атакующего блокирует (у него же висят триггеры).
  if (attacker.current?.silenced) return;
  if (attacker.silenceSources && attacker.silenceSources.size > 0) return;
  // Ванильная копия (Конвейер тел, stats:1/0/1|no_triggers) — без on-attack.
  if (attacker.noTriggers) return;
  // Атакующий должен быть жив (контратака могла прийти в одновременно
  // умирающую цель — на момент fire атакующий уже мёртв; считаем что
  // удар состоялся, эффект тоже).
  const dmg = Math.max(0, damageDealt | 0);
  for (const fn of arr) {
    try {
      fn(state, attacker, target, dmg);
    } catch (e) {
      console.warn(`[Корпы] on_attack-триггер ${attacker.id} упал:`, e);
    }
  }
}
